// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__URCEb","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3ghJp","obliqueLine":"membershipbadge_obliqueLine__e9vJO"};